module.exports = __webpack_public_path__ + "static/media/icon_customer_active.68d95aac.svg";